// extracted by mini-css-extract-plugin
export default {"container":"FasilitasForm_container__3lhz9","card":"FasilitasForm_card__01r7H","title":"FasilitasForm_title__CVMl4"};